
(function () {
  var $ = function (id) {
    return document.getElementById(id);
  };
  var val = function (id) {
    var el = $(id);
    return el ? el.value : "";
  };
  var turnstileToken = "";
  var turnstileWidgetId = null;

  function emailLooksValid(v) {
    return /^\S+@\S+\.\S+$/.test(v);
  }

  function phoneLooksValid(v) {
    return v.trim() === "" || /^[0-9 ()+-]{6,}$/.test(v);
  }

  function getValues() {
    return {
      company: val("company").trim(),
      firstName: val("firstName").trim(),
      lastName: val("lastName").trim(),
      email: val("email").trim(),
      phone: val("phone").trim(),
      countryCode: val("phoneCountry"),
      enquiryMessage: val("enquiryMessage").trim(),
      recaptcha: turnstileToken,
    };
  }

  function toggleTooltip(fieldIdOrEl, show, force) {
    var field = typeof fieldIdOrEl === "string" ? $(fieldIdOrEl) : fieldIdOrEl;
    if (!field) return;
    var tooltipId = field.getAttribute("aria-describedby");
    if (!tooltipId) return;
    var touched = force || field.dataset.touched === "true";
    tooltipId.split(" ").forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.style.display = touched && show ? "block" : "none";
    });
    field.setAttribute("aria-invalid", String(touched && show));
  }

  function validate(force) {
    var v = getValues();
    var contactProvided = v.email !== "" || v.phone !== "";
    var isValid = {
      firstName: v.firstName !== "",
      lastName: v.lastName !== "",
      enquiryMessage: v.enquiryMessage !== "",
      contactProvided: contactProvided,
      email: v.email === "" || emailLooksValid(v.email),
      phone: phoneLooksValid(v.phone),
      recaptcha: !!v.recaptcha,
    };
    toggleTooltip("firstName", !isValid.firstName, force);
    toggleTooltip("lastName", !isValid.lastName, force);
    toggleTooltip("enquiryMessage", !isValid.enquiryMessage, force);
    toggleTooltip("email", !isValid.email, force);
    toggleTooltip("phone", !isValid.phone, force);
    var contactTooltip = document.getElementById("contact-tooltip");
    if (contactTooltip) {
      var emailTouched =
        force || ($("email") && $("email").dataset.touched === "true");
      var phoneTouched =
        force || ($("phone") && $("phone").dataset.touched === "true");
      contactTooltip.style.display =
        !isValid.contactProvided && (emailTouched || phoneTouched)
          ? "block"
          : "none";
    }
    var recaptchaEl = document.getElementById("cf-turnstile-response");
    if (recaptchaEl) {
      if (force) recaptchaEl.dataset.touched = "true";
      if (recaptchaEl.dataset.touched === "true") {
        toggleTooltip(recaptchaEl, !isValid.recaptcha, force);
      }
    }
    var allValid =
      isValid.firstName &&
      isValid.lastName &&
      isValid.enquiryMessage &&
      isValid.recaptcha &&
      isValid.email &&
      isValid.phone &&
      isValid.contactProvided;
    var btn = document.getElementById("submit-btn");
    if (!btn) return allValid;
    btn.disabled = !allValid;
    btn.setAttribute("aria-disabled", String(!allValid));
    return allValid;
  }

  function markAllTouched() {
    document
      .querySelectorAll(
        "#fa-form-2 input, #fa-form-2 select, #fa-form-2 textarea",
      )
      .forEach(function (el) {
        el.dataset.touched = "true";
      });
    var rec = document.getElementById("cf-turnstile-response");
    if (rec) rec.dataset.touched = "true";
  }

  function renderTurnstile() {
    var init = function () {
      if (!window.turnstile) return;
      if (turnstileWidgetId !== null) {
        try {
          window.turnstile.reset(turnstileWidgetId);
        } catch (e) {
          turnstileWidgetId = null;
        }
      } else {
        turnstileWidgetId = window.turnstile.render("#turnstile-container", {
          sitekey: "0x4AAAAAABgIfOSwEbH55ANd",
          callback: function (token) {
            turnstileToken = token;
            var el = document.getElementById("cf-turnstile-response");
            if (!el) return;
            el.value = token;
            el.dataset.touched = "true";
            validate();
          },
          "expired-callback": function () {
            turnstileToken = "";
            var el = document.getElementById("cf-turnstile-response");
            if (!el) return;
            el.value = "";
            el.dataset.touched = "true";
            validate();
          },
          "error-callback": function () {
            turnstileToken = "";
            var el = document.getElementById("cf-turnstile-response");
            if (!el) return;
            el.value = "";
            el.dataset.touched = "true";
            validate();
          },
        });
      }
    };
    var script = document.querySelector(
      'script[src*="challenges.cloudflare.com/turnstile"]',
    );
    if (window.turnstile) init();
    else if (script) script.addEventListener("load", init);
  }

  function attachValidationListeners() {
    ["input", "select", "textarea"].forEach(function (type) {
      document.querySelectorAll("#fa-form-2 " + type).forEach(function (el) {
        el.addEventListener("input", function () {
          validate();
        });
        el.addEventListener("blur", function () {
          el.dataset.touched = "true";
          validate();
        });
      });
    });
  }

  function handleSubmit(e) {
    markAllTouched();
    if (!validate(true)) {
      e.preventDefault();
      var err = document.querySelector(
        '#fa-form-2 .field-tooltip[style*="block"]',
      );
      if (err) err.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }
    setSubmittingState();
  }

  function setSubmittingState() {
    var btn = document.getElementById("submit-btn");
    if (!btn) return;
    btn.disabled = true;
    btn.setAttribute("aria-disabled", "true");
    btn.setAttribute("aria-busy", "true");
    var spinner = document.createElement("span");
    spinner.className = "spinner";
    spinner.setAttribute("aria-hidden", "true");
    var status = document.createElement("span");
    status.setAttribute("role", "status");
    status.setAttribute("aria-live", "polite");
    status.textContent = "Submitting...";
    btn.textContent = "";
    btn.appendChild(spinner);
    btn.appendChild(document.createTextNode(" "));
    btn.appendChild(status);
  }

  function showPopup(message, type) {
    var msgEl = $("popup-message");
    var popup = $("popup");
    var overlay = $("overlay");
    if (!msgEl || !popup || !overlay) return;
    msgEl.textContent = message;
    popup.className = type;
    overlay.style.display = "flex";
    msgEl.focus();
  }

  function attachPopupClose() {
    var close = $("close-popup");
    if (!close) return;
    close.addEventListener("click", function () {
      var overlay = $("overlay");
      if (overlay) overlay.style.display = "none";
    });
  }

  function showPopupFromQuery() {
    var params = new URLSearchParams(location.search);
    var code = (params.get("code") || "").toLowerCase();
    if (!code) return;
    var msg =
      code === "ok"
        ? "Submitted successfully!"
        : "Something went wrong. Please try again.";
    showPopup(msg, code === "ok" ? "success" : "error");
    if (history && history.replaceState) {
      var url = new URL(location.href);
      url.searchParams.delete("code");
      history.replaceState({}, "", url.toString());
    }
  }

  window.addEventListener("DOMContentLoaded", function () {
    if (!document.getElementById("fa-form-2")) return;
    var startTime = $("startTime");
    if (startTime) startTime.value = Date.now();
    renderTurnstile();
    attachValidationListeners();
    attachPopupClose();
    validate();
    var form = document.getElementById("fa-form-2");
    if (form) form.addEventListener("submit", handleSubmit);
    showPopupFromQuery();
  });
})();
